import React from 'react';
import Modal from 'react-modal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useRecoilState } from 'recoil';
import { videoListState } from '../../stores/vass/videoListState';

// NOTE Vass CCTV 위치 변경 모달
const CCTVEditModalComponent = ({ isOpen, onRequestClose, props }) => {
  Modal.setAppElement('#root');
  const [videoList, setVideoList] = useRecoilState(videoListState); // CCTV 리스트

  const handleDragEnd = (result) => {
    if (!result.destination) return;
  
    const reorderedList = Array.from(videoList);
    const [movedItem] = reorderedList.splice(result.source.index, 1);
    reorderedList.splice(result.destination.index, 0, movedItem);
  
    setVideoList(reorderedList);
  };

  return (
    // 기본 모달 옵션 설정
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.3)', // 어두운 배경색
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '400px', // 모달 너비
          height: '700px', // 모달 높이
          padding: '20px', // 모달 패딩
          borderRadius: '10px', // 모달 경계 둥글기
          backgroundColor: props.theme.white1,
          border: `1px solid ${props.theme.white4}`, // 드래그 가능한 항목의 테두리
        },
      }}
    >
      <h4>CCTV 위치 변경</h4>
      {/* CCTV 위치 변경 라이브러리 */}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="videoList">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={{ overflowY: 'auto', maxHeight: 'calc(100% - 60px)' }} // 드래그 가능한 영역의 최대 높이 설정
            >
              {videoList.map((video, index) => (
                <Draggable key={video.cam_id} draggableId={video.cam_id} index={index}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...provided.draggableProps.style,
                        backgroundColor: props.theme.white3,
                        padding: '10px', // 드래그 가능한 항목의 패딩
                        margin: '5px 0', // 드래그 가능한 항목의 마진
                        borderRadius: '5px', // 드래그 가능한 항목의 경계 둥글기
                      }}
                    >
                      <p>{video.cam_name}</p>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <button onClick={onRequestClose}
      style={{marginTop: "10px", border: 0, width: "100px", padding: 5, borderRadius: 10, backgroundColor: props.theme.white4, color: "unset"}}>닫기</button>
    </Modal>
  );
};

export default CCTVEditModalComponent;
